import styled, { css } from 'styled-components';

import colors from '~/styles/colors';

interface Props {
  size: 'xs' | 'sm' | 'md' | 'lg';
}

export const Container = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 6000;
`;

export const Content = styled.div<Props>`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  padding: 20px 20px;
  max-height: calc(100% - 50px);

  width: 100%;
  ${(props) =>
    props.size === 'xs' &&
    css`
      max-width: 500px;
    `}
  ${(props) =>
    props.size === 'sm' &&
    css`
      max-width: 600px;
    `}

  ${(props) =>
    props.size === 'md' &&
    css`
      max-width: 800px;
    `}

  ${(props) =>
    props.size === 'lg' &&
    css`
      max-width: 1069px;
    `}

  h1 {
    font-size: 26px;
    font-weight: 500;
  }

  img {
    width: 100%;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
    margin: 16px 0 26px 0;
  }
`;

export const Title = styled.span`
  font-size: 24px;
  color: #4d4d4d;
  padding: 0 30px 0 0;
`;

export const Subtitle = styled.span`
  font-size: 12px;
  color: ${colors.darkred};
  padding: 0 30px 0 0;
  margin-top: 8px;
`;

export const CloseButton = styled.button`
  position: absolute;
  border: 0;
  background: none;
  align-self: flex-end;
  z-index: 3;

  svg {
    fill: ${colors.gray};
  }
`;

export const ContentWithSidebar = styled.div<Props>`
  display: flex;
  flex-direction: row;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  padding: 0;
  margin-top: 80px;
  max-height: calc(100% - 50px - 80px);

  ${(props) =>
    props.size === 'sm' &&
    css`
      width: 770px;
    `}

  ${(props) =>
    props.size === 'md' &&
    css`
      width: 900px;
    `}

  ${(props) =>
    props.size === 'lg' &&
    css`
      width: 1069px;
    `}

  h1 {
    font-size: 26px;
    font-weight: 500;
  }

  h2.detailsHead {
    font-size: 22px;
    font-weight: normal;
    color: #808080;
    margin: 20px 0px 0px 0px;

    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: rgba(0, 0, 0, 0.1);
      margin: 16px 0 10px 0;
    }
  }
`;

export const ModalSidebar = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 0px 5px 5px 0px;
  padding: 0 0 0 30px;
  width: 250px;
  background: #f4f4f4;

  h3 {
    font-size: 16px;
    color: #4d4d4d;
    margin: 30px 0px 0;
  }
`;

export const ModalWithSidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 5px;
  padding: 20px 20px;
  width: 700px;
`;

export const ModalResponsavel = styled.div`
  display: flex;
  flex-direction: row;

  font-size: 14px;
  color: #808080;

  padding-top: 10px;

  & > div {
    margin-right: 10px;
  }
`;

export const ModalResponsaveis = styled.div`
  font-size: 24px;
  color: #4d4d4d;
`;

export const ModalScrollBar = styled.div`
  padding-right: 15px;
  overflow-y: auto;
`;
